export interface Volume {
  code: string
  name: string
  count: string
  intro: string
  solves: string
  result: string
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'Velocità, Accelerazione e Meccanica',
    count: '+12 sessioni pratiche',
    intro:
      "Domina l'insegnamento di partenze, accelerazione e velocità massima. Esercizi organizzati con progressione chiara: dalla postura di base alla partenza reattiva a massima intensità.",
    solves:
      'Atleti che non partono bene, che corrono “seduti” o che non capiscono la differenza tra spinta iniziale e velocità massima.',
    result:
      'I tuoi velocisti accelerano più velocemente e capiscono il gesto tecnico dal primo passo.',
  },
  {
    code: '02',
    name: 'Ostacoli e Staffette',
    count: '+11 sessioni pratiche',
    intro:
      'La guida per insegnare il ritmo tra le barriere e la sincronizzazione perfetta nei cambi di testimone. Esercizi di mobilità specifica e progressioni per ogni livello.',
    solves:
      "Atleti che saltano invece di attraversare l'ostacolo, che perdono ritmo tra le barriere o che atterrano sbilanciati.",
    result:
      'Tecnica di ostacolo sicura e ritmo coordinato. Cambi di testimone precisi e fluidi.',
  },
  {
    code: '03',
    name: 'Mezzofondo, Fondo e Marcia',
    count: '+13 sessioni pratiche',
    intro:
      'Programmazione scientifica della resistenza. Tabelle di ritmi, gestione degli intervalli e tecnica avanzata di marcia atletica.',
    solves:
      'Atleti senza ritmo, stanchezza prematura, tecnica di marcia impropria e gestione tattica della gara.',
    result:
      'Atleti di resistenza forti ed economici nella corsa. Marcia atletica tecnica e regolamentare.',
  },
  {
    code: '04',
    name: 'Salti: Elevazione e Potenza',
    count: '+12 sessioni pratiche',
    intro:
      'Protocolli per salto in lungo, triplo, alto e asta. Dalla stabilizzazione della rincorsa alla fase di stacco e atterraggio.',
    solves:
      'Atleti che perdono velocità prima del salto, che non stabilizzano gli ultimi tre passi o che non staccano correttamente.',
    result:
      'Rincorse stabili, stacchi precisi e potenti. Progressi reali in ogni gara.',
  },
  {
    code: '05',
    name: 'Lanci: Forza e Coordinazione',
    count: '+9 sessioni pratiche',
    intro:
      'Tecnica pura per peso, disco, giavellotto e martello. Come insegnare la catena cinetica e massimizzare la gittata senza infortuni.',
    solves:
      "Atleti che lanciano solo con il braccio, che non usano le gambe, che perdono equilibrio o che non trasferiscono forza dall'anca.",
    result:
      'Lanci più lunghi, tecnica sicura e coordinazione perfetta della catena cinetica.',
  },
  {
    code: '06',
    name: 'Gestione Gruppi Misti e Pianificazione',
    count: '+13 sessioni integrate',
    intro:
      'Il cuore logistico del sistema. Come allenare 20 atleti di specialità diverse contemporaneamente nello stesso spazio senza perdere il controllo.',
    solves:
      'Caos organizzativo, atleti inattivi, impossibilità di adattare gli esercizi ai diversi livelli e tempo perso tra le sessioni.',
    result:
      'Pista ordinata, tutti occupati, struttura chiara a stazioni e adattamenti facili per ogni livello.',
  },
]
